import classNames from 'classnames';
import {setTestId} from 'js/reusable/testing/setTestId';
import React from 'react';

interface IProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> {
	disabled?: boolean,
	icon?: string,
	testId?: string,
}

function Spinner({className, disabled = false, icon = 'fa-circle-notch', testId, ...rest}: IProps) {
	const cssClasses = classNames(
		'fas fa-spin',
		{
			'disabled': disabled,
		},
		className, icon);

	return (
		<i
			data-testid={setTestId(testId)}
			className={cssClasses}
			{...rest}
		/>
	);
}

export default Spinner;
